import { Timestamp } from 'firebase/firestore';

import { IAdmin, IUser, IMeasurement } from 'types';

export const CURRENT_ADMIN: IAdmin = {
  id: '0001',
  email: 'alexander@sweetcode.pro',
  firstName: 'Alexander',
  lastName: 'Zheleznov',
  role: 'Superadmin',
  createdAt: Timestamp.now(),
  isActive: true,
};

export const USERS: IUser[] = [
  {
    id: '001',
    firstName: 'Cameron',
    lastName: 'Williamson',
    email: 'alma.lawson@example.com',
    saved: [],
    shared: [],
    createdAt: Timestamp.now(),
    country: 'USA',
  },
  {
    id: '002',
    firstName: 'Bessie',
    lastName: 'Cooper',
    email: 'michael.mitc@example.com',
    saved: [],
    shared: [],
    createdAt: Timestamp.now(),
    country: 'USA',
  },
  {
    id: '003',
    firstName: 'Guy',
    lastName: 'Hawkins',
    email: 'georgia.young@example.com',
    saved: [],
    shared: [],
    createdAt: Timestamp.now(),
    country: 'USA',
  },
  {
    id: '004',
    firstName: 'Kristin',
    lastName: 'Watson',
    email: 'tanya.hill@example.com',
    saved: [],
    shared: [],
    createdAt: Timestamp.now(),
    country: 'Canada',
  },
  {
    id: '005',
    firstName: 'Savannah',
    lastName: 'Nguyen',
    email: 'willie.jennings@example.com',
    saved: [],
    shared: [],
    createdAt: Timestamp.now(),
    country: 'Canada',
  },
  {
    id: '006',
    firstName: 'Leslie',
    lastName: 'Alexander',
    email: 'nathan.roberts@example.com',
    saved: [],
    shared: [],
    createdAt: Timestamp.now(),
    country: 'Italy',
  },
];

export const MEASUREMENTS: IMeasurement[] = [
  {
    id: 'CookingTimes',
    values: [
      { value: '0-5 min' },
      { value: '5-10 min' },
      { value: '10-15 min' },
      { value: '15-20 min' },
      { value: '20-30 min' },
      { value: '30-40 min' },
      { value: '40-50 min' },
      { value: '50-60 min' },
    ],
  },
];
